// extracted by mini-css-extract-plugin
export default {"root":"BurgerMenu_root__zxnHc","slideout":"BurgerMenu_slideout__E1fLZ","hidden":"BurgerMenu_hidden__4DTci","slidein":"BurgerMenu_slidein__9iZus"};